export const appConfig = {
  serviceUrl: process.env.REACT_APP_PLATFORM_API_URL || 'http://localhost:3000',
};
